export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informazioni di registrazione"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confermato"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accessibile al pubblico"])}
}